import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import UIAssetKeys from '../UIAssetKeys';
import FontKeys from '../FontKeys';

export default class PausePopup extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   * @param {number} x 
   * @param {number} y 
   */
  constructor(scene, x, y) {
    super(scene, x, y);

    this.scene.add.existing(this);

    this._screenBlock = this.scene.add.rectangle(0, this.scene.scale.height / 2 - y, this.scene.scale.width, this.scene.scale.height, 0x000000, 0.25).setInteractive();
    this.add(this._screenBlock);
    this._bg = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._game_items_pause_bg, this);
    this._resumeButton = this.scene.add.container(0, -61);
    this.add(this._resumeButton);
    const resumeBg = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._game_items_btn_resume, this._resumeButton);
    ABCyaPhaser.Container.setContainerInteractive(this._resumeButton);
    const resumeTxt = ABCyaPhaser.Text.addText(32, 0, 50, 0x60ba47, FontKeys._odin_roundedregular, ABCyaPhaser.Localization.instance.getLocalizedString("resume_button"), this._resumeButton);
    ABCyaPhaser.Text.resizeFontToFitWidth(resumeTxt, 200, 50, 50);
    ABCyaPhaser.Buttons.convertToButton(this._resumeButton, { onClick: () => this.emit(PAUSE_POPUP_EVENTS.resume) });

    this._homeButton = this.scene.add.container(0, 63);
    this.add(this._homeButton);
    const homeBg = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._game_items_btn_home, this._homeButton);
    ABCyaPhaser.Container.setContainerInteractive(this._homeButton);
    const homeTxt = ABCyaPhaser.Text.addText(32, 0, 50, 0x60ba47, FontKeys._odin_roundedregular, ABCyaPhaser.Localization.instance.getLocalizedString("home_button"), this._homeButton);
    ABCyaPhaser.Text.resizeFontToFitWidth(homeTxt, 200, 50, 50);
    ABCyaPhaser.Buttons.convertToButton(this._homeButton, { onClick: () => this.emit(PAUSE_POPUP_EVENTS.quit) });

    this.disableButtons();
  }

  enableButtons() {
    this._resumeButton.setInteractive();
    this._homeButton.setInteractive();
  }

  disableButtons() {
    this._resumeButton.disableInteractive();
    this._homeButton.disableInteractive();
  }
}

export const PAUSE_POPUP_EVENTS =
{
  resume: "resume",
  quit: "quit"
}